import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { catchError, EMPTY, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const token = tokenService.getToken();
  const router = inject<any>(Router);

  if (token != null) {
    let clone = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    })

    return next(clone).pipe(
      catchError( (err: HttpErrorResponse) => {
          if (err.status === 401) {
              tokenService.clearToken();
              router.navigate(['/auth/login']);
              return EMPTY; // stop the current request
          }
          return throwError(() => err);
      })
    );
  }
  return next(req); 
};

export const tokenInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useValue: tokenInterceptor,
  multi: true
} 
